import { render } from "./raised_button.vue?vue&type=template&id=16c1f0b6"
import script from "./raised_button.vue?vue&type=script&lang=js"
export * from "./raised_button.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__